import React from 'react';
import { motion } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
type MetaItem = {
  label: string;
  value: string;
};
type CaseHeaderProps = {
  overline: string;
  title: string;
  intro: string;
  meta: MetaItem[];
};
export function CaseHeader({
  overline,
  title,
  intro,
  meta
}: CaseHeaderProps) {
  const enter = (delay: number) => ({
    initial: {
      opacity: 0,
      y: 12
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease: EASE_OUT,
      delay
    }
  });
  return <header data-id="element-79" data-mp="fbnc2tte875d">
      <motion.p {...enter(0)} className="text-xs font-medium uppercase tracking-[0.14em] text-rust" data-id="element-80" data-mp="fd84acs8je02">
        {overline}
      </motion.p>
      <motion.h1 {...enter(0.05)} className="mt-4 max-w-3xl text-[34px] font-semibold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-81" data-mp="aiu4ly6jikpl">
        {title}
      </motion.h1>
      <motion.p {...enter(0.12)} className="mt-6 max-w-2xl text-base leading-relaxed text-fg-muted" data-id="element-82" data-mp="133lz2b27fqyc">
        {intro}
      </motion.p>
      <motion.dl {...enter(0.18)} className="mt-10 grid grid-cols-2 gap-6 border-t border-line pt-6 md:grid-cols-4" data-id="element-83" data-mp="uy5no2lk8xnq">
        {meta.map(m => <div key={m.label} data-id="element-84" data-mp="zx0ftv5f3yki">
            <dt className="text-xs text-fg-faint" data-id="element-85" data-mp="l8vvkmqpvezm">{m.label}</dt>
            <dd className="mt-1 text-sm font-medium text-fg" data-id="element-86" data-mp="l8cm7uf4tyx7">{m.value}</dd>
          </div>)}
      </motion.dl>
    </header>;
}